export const ELEM_DATASET_BASE_MIXIN_NAME = 'ElemDatasetBaseMixin';
export const ELEM_DATASET_MIXIN_NAME = 'ElemDatasetMixin';
export const ELEM_DATASET_WATCH_STORE_MIXIN_NAME = 'ElemDatasetWatchStoreMixin';
export const ELEM_DATASET_DRILLDOWN_MIXIN_NAME = 'ElemDatasetDrilldownMixin';
export const ELEM_DATASET_DEVIATIONS_MIXIN_NAME = 'ElemDatasetDeviationsMixin';
